export enum PolicyTypeId {
  TYPE_1 = 1,
  TYPE_2 = 2,
  TYPE_3 = 3,
  TYPE_ALL = -1,
  TYPE_4 = 4,
  TYPE_5 = 5,
}

export const PolicyFilter = {
  ALL_POLICIES: 'all-policies',
};
